import type { AnyAction, Reducer } from '@reduxjs/toolkit'

type RemoveUndefined<T> = Exclude<T, null | undefined>

const reducersMerge =
  <
    TReducers extends Reducer[],
    TState = Parameters<TReducers[number]>[0],
    TAction extends AnyAction = Parameters<TReducers[number]>[1],
  >(
    ...reducers: TReducers
  ) =>
  (state: TState, action: TAction) => {
    let newState = state
    for (const reducer of reducers) {
      newState = reducer(newState, action) || newState
    }
    return newState as RemoveUndefined<TState>
  }

export default reducersMerge
